/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectionsuperseded1Inputs */



/**
* | output |
* | --- |
* | "Opened on another device" |
*
* @param {Connectionsuperseded1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const connectionsuperseded1 = /** @type {((inputs?: Connectionsuperseded1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectionsuperseded1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Opened on another device")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abierto en otro dispositivo")
	return /** @type {LocalizedString} */ ("Открыто на другом устройстве")
});
export { connectionsuperseded1 as "connectionSuperseded" }